import {
  Box,
  Container,
  FormControlLabel,
  Paper,
  Switch,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import Title from "../../../../components/title";
import { useEffect, useState } from "react";
import { PermissionsPage } from "../../../../util/permissionsPage";
import { StyledTableCell } from "../../../franchise/components/StyledTableCell";
import SearchIcon from "@mui/icons-material/Search";

import { FuncionariosRow } from "../components/FuncionariosRow";
import {
  Search,
  SearchIconWrapper,
  StyledInputBase,
} from "../../../../components/SearchComponent/SearchComponent";
import { debounce } from "throttle-debounce";
import { NoData } from "../../../../components/NoData/NoData";
import { LoadingTable } from "../../../../components/Loading/LoadingTable";
import { funcionariosService } from "../../../../services/funcionarios";
import { toast } from "react-hot-toast";

export const FuncionariosList = () => {
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [total, setTotal] = useState(0);
  const [data, setData] = useState([]);
  const [inativos, setInativos] = useState(false);

  const [params, setParams] = useState({
    page: 1,
    per_page: 10,
    search_term: "",
  });

  const handleChangePage = (event, newPage) => {
    setParams((old) => ({ ...old, page: newPage + 1 }));
  };

  const handleSearch = (ev) => {
    setParams((old) => ({ ...old, search_term: ev, page: 1, per_page: 10 }));
  };

  const handleChangeRowsPerPage = (event) => {
    setParams((old) => ({ ...old, per_page: +event.target.value, page: 1 }));
  };

  const debounceFunc = debounce(500, handleSearch);

  const getData = async () => {
    setIsLoadingData(true);
    try {
      const response = await funcionariosService.getFuncionarios({
        page: params.page,
        rowsPerPage: params.per_page,
        active: !inativos,
        ...(params.search_term && { searchTerm: params.search_term }),
      });

      if (response.status === 200) {
        setData(response.data.items || []);
        setTotal(response.data.total || 0);
      } else {
        toast.error("Erro ao buscar funcionários");
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || "Erro ao buscar funcionários";
      toast.error(errorMessage);
      setData([]);
      setTotal(0);
    } finally {
      setIsLoadingData(false);
    }
  };

  useEffect(() => {
    getData();
  }, [params, inativos]);

  const toggleInativos = (event) => {
    setInativos(event.target.checked);
    setParams((old) => ({ ...old, page: 1 }));
  };

  return (
    <>
      {PermissionsPage("configuracaoAcesso") && (
        <>
          <Container className="containerFlexBox">
            <Title title="COLABORADORES" />
          </Container>
      
      <Box
        component={Container}
        marginY={2}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Search>
          <SearchIconWrapper>
            <SearchIcon />
          </SearchIconWrapper>
          <StyledInputBase
            sx={{
              borderRadius: "4px",
              borderColor: "#d6d6d6 !important",
              border: "1px solid",
            }}
            disabled={isLoadingData}
            placeholder="Digite seu nome"
            inputProps={{ "aria-label": "search" }}
            onChange={(e) => debounceFunc(e.target.value)}
          />
        </Search>

        <FormControlLabel
          control={
            <Switch
              checked={inativos}
              onChange={toggleInativos}
              color="default"
              sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#ccc' }, '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#ccc' } }}
            />
          }
          label={<span style={{ fontSize: '14px', color: '#555' }}>Colaboradores Inativos</span>}
        />
      </Box>

      {isLoadingData ? (
        <LoadingTable />
      ) : (
        <Container sx={{ paddingBottom: "2rem" }}>
          {data.length <= 0 ? (
            <Box
              width={"100%"}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <NoData />
            </Box>
          ) : (
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              <TableContainer>
                <Table stickyHeader size={"small"} aria-label="collapsible table" sx={{ '& tbody tr:nth-of-type(even)': { backgroundColor: '#f9f9f9' } }}>
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>Id</StyledTableCell>
                      <StyledTableCell>Código RAD</StyledTableCell>
                      <StyledTableCell>Base</StyledTableCell>
                      <StyledTableCell>Nome</StyledTableCell>
                      <StyledTableCell>Opções</StyledTableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {data.map((row) => (
                      <FuncionariosRow key={row.id} row={row} />
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[
                  10,
                  25,
                  50,
                  100,
                  { label: "Todos", value: total },
                ]}
                component="div"
                count={total}
                rowsPerPage={params.per_page}
                page={params.page - 1}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage={"Linhas por pagina"}
                SelectProps={{
                  inputProps: {
                    "aria-label": "rows per page",
                  },
                  native: true,
                }}
              />
            </Paper>
          )}
        </Container>
      )}
        </>
      )}
    </>
  );
};
